import Layout from '@/layout';
export default {
  path: '/area',
  component: Layout,
  redirect: '/area/index',
  name: 'Area',
  meta: {
    title: '店铺分组管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/area/index');
    },
    name: 'AreaIndex',
    meta: {
      title: '店铺分组列表'
    }
  }, {
    path: 'create/:id?',
    component: function component() {
      return import('@/views/area/create');
    },
    name: 'AreaCreate',
    meta: {
      title: '店铺分组维护',
      activeMenu: '/area/index',
      noCache: true
    },
    hidden: true
  }, {
    path: 'areamenu/index',
    component: function component() {
      return import('@/views/area/areamenu/index');
    },
    name: 'AreaMenu',
    meta: {
      title: '商户主体菜单管理'
    }
  }, {
    path: 'areamenu/indexf',
    component: function component() {
      return import('@/views/area/areamenu/indexf');
    },
    name: 'AreaMenuF',
    meta: {
      title: '商户主体菜单管理'
    }
  }, {
    path: 'areamenu/platformBusinessRole',
    component: function component() {
      return import('@/views/area/areamenu/platformBusinessRole');
    },
    name: 'PlatformBusinessRole',
    meta: {
      title: '商户主体超管管理'
    }
  }]
};